// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"78ec229e","453":"2abfd264"}[chunkId] + ".chunk.js";
};